import React from 'react'
import PropTypes from 'prop-types'
import { Form, Typography } from 'antd'
import { SelectF } from '@/i2antdV5'

const FormItem = Form.Item
const { Text } = Typography

/**
 * baseProps 契约：
 * - deviceIds：待分配设备 id 列表
 * - storeOptions：门店下拉 [{ id, value }, ...]
 */
class BatchAssignYingshiDeviceStoreForm extends React.Component {
  static propTypes = {
    form: PropTypes.object,
    baseProps: PropTypes.object
  }

  static defaultProps = {
    baseProps: {}
  }

  render () {
    const { form, baseProps } = this.props
    const { deviceIds = [], storeOptions = [] } = baseProps || {}
    const count = Array.isArray(deviceIds) ? deviceIds.length : 0

    return (
      <Form ref={form} layout="vertical">
        <Text type="secondary" style={{ display: 'block', marginBottom: 12 }}>
          将把已选 {count} 台设备分配到下方店铺
        </Text>
        <FormItem
          label="目标店铺"
          name="storeId"
          rules={[{ required: true, message: '请选择目标店铺' }]}
        >
          <SelectF
            options={storeOptions}
            modalProps={{ placeholder: '选择目标店铺' }}
          />
        </FormItem>
      </Form>
    )
  }
}

export default BatchAssignYingshiDeviceStoreForm
